import { NgModule, inject } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { CropMonitoringSummaryComponent } from '@app/pages/crop-monitoring/crop-monitoring-summary/crop-monitoring-summary';
import { RequestsPageComponent } from '@app/pages/crop-monitoring/pages/request/requests-page';
import { RequestAddPageComponent } from '@app/pages/crop-monitoring/components/request-add-page/request-add-page';
import { MobileTemplatesPageComponent } from './pages/mobile-templates-page/mobile-templates-page';
import { TaskSchedulerPageComponent } from '@app/pages/admin/task-scheduler-page/task-scheduler-page';
import { UserManagementPageComponent } from '@app/pages/user-management/user-management-page/user-management-page';
import { ElectronicFieldMapPageComponent } from '@app/pages/admin/administration-summary/administration-summary';
import { LoggingPageComponent } from '@app/pages/admin/logging-page/logging-page';
import { AppealsPageComponent } from '@app/pages/admin/appeals-page/appeals-page';
import { SystemStatusPageComponent } from '@app/pages/admin/system-status-page/system-status-page';
import { FileStorageManagementPageComponent } from './pages/file-storage-management-page/file-storage-management-page';
import { SystemDocumentationPageComponent } from '@app/pages/admin/system-documentation-page/system-documentation-page';
import { SystemDocumentationBlocksPageComponent } from '@app/pages/admin/system-documentation-blocks-page/system-documentation-blocks-page';
import { DataManagementPageComponent } from '@app/pages/admin/data-management-page/data-management-page';
import { NotFoundComponent } from './pages/not-found/not-found';
import { UnderDevelopmentComponent } from '@components/under-development/under-development.component';
import { ApiTestComponent } from '@components/api-test/api-test.component';
import { CallbackComponent } from '@components/callback/callback.component';
import { authCheckGuard } from './guards/auth-check.guard';
import { AdminGuard } from './guards/admin.guard';
import { AuthErrorComponent } from '@components/auth-error/auth-error.component';
import { LoginPageComponent } from './pages/login-page/login-page';
import { MainMenuComponent } from '@app/pages/main-menu/main-menu.component';
import { PassportMenuGeneral } from '@app/pages/electronic-field-map/pages/fields/passport/menu/passport-menu-general/passport-menu-general';
import { DataTableDemoComponent } from '@app/pages/data-table-demo/data-table-demo.component';
import { UserSupportTicketsPageComponent } from './pages/user-support-tickets-page/user-support-tickets-page.component';
import { TileMap } from '@app/pages/weather/pages/tile-map/tile-map';
import { WeatherLoggingComponent } from './pages/weather-page/weather-logging/weather-logging.component';
import { WeatherAdministrationMenuComponent } from './pages/weather-page/weather-administration-menu/weather-administration-menu.component';
import { WeatherMainMenuComponent } from '@app/pages/weather/weather-main-menu.component';
import { ChatComponent } from './pages/chat-component/chat.component';
import { SatelliteImagesComponent } from './pages/satellite-images/satellite-images.component';
import { SatelliteImagesAdminComponent } from './pages/satellite-images-admin/satellite-images-admin.component';
import { SatelliteDataComponent } from './pages/satellite-data/satellite-data.component';
import { UserChatComponent } from './pages/user-support-tickets-page/user-chat.component';
import { DocumentationPageComponent } from './pages/help/documentation-page/documentation-page';
import { UavDataComponent } from './pages/uav-data-page/uav-data.component';
import { GisPageRefactoredNewComponent } from '@app/pages/weather/pages/gis-weather/gis-page.component.refactored.new';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { CropMonitoringSatelliteComponent } from './pages/crop-monitoring-satellite/crop-monitoring-satellite.component';
import { GisRequestComponent } from '@app/pages/crop-monitoring/gis-request/gis-request';
import { CropYieldForecastsPageComponent } from './pages/crop-yield-forecasts-page/crop-yield-forecasts-page.component';
import { CropIdentificationMainComponent } from '@app/pages/crop-identification/crop-identification-main.component';
import { GisCropIdentification } from '@app/pages/crop-identification/pages/gis-crop-identification/gis-crop-identification';
import { CropIdentificationList } from '@app/pages/crop-identification/pages/crop-identification-list/crop-identification-list';
import { CropYieldForecastListComponent } from './pages/crop-yield-forecasts-page/crop-yield-forecast-list/crop-yield-forecast-list.component';
import { CropYieldAnalysisComponent } from './pages/crop-yield-forecasts-page/crop-yield-analysis/crop-yield-analysis.component';
import { FieldsIdentificationPageComponent } from './pages/fields-identification-page/fields-identification.component';
import { FieldsIdentificationListComponent } from './pages/fields-identification-page/fields-identification-list/fields-identification-list.component';
import { FieldsIdentificationMapComponent } from './pages/fields-identification-page/fields-identification-map/fields-identification-map.component';
import { CropMonitoringAdministrationMenuComponent } from './pages/crop-monitoring-page/crop-monitoring-administration-menu/crop-monitoring-administration-menu.component';
import { AnomaliesMapPageComponent } from '@app/pages/crop-monitoring/pages/anomalies/anomalies-map-page';
import {CropMonitoringPageComponent} from '@app/pages/crop-monitoring-page/crop-monitoring-page';
import {FarmerRecommendationsPageComponent} from '@app/pages/crop-monitoring/pages/farmer-recommendations/farmer-recommendations-page';
import { MaintenancePageComponent } from '@app/pages/admin/maintenance-page/maintenance-page';
import { ReportingAnalyticsPageComponent } from './pages/reporting-analytics/reporting-analytics-page.component';
import { MobileSettingsPageComponent } from '@app/pages/admin/mobile-settings-page/mobile-settings-page';
import { OperationMonitoringPageComponent } from '@app/pages/admin/operation-monitoring-page/operation-monitoring-page';
import { ProcessSubscriptionsPageComponent } from '@app/pages/admin/process-subscriptions-page/process-subscriptions-page';
import { AssignmentsPageComponent } from '@app/pages/admin/assignments-page/assignments-page';
import { OperationDetailsDialogComponent } from '@app/pages/admin/operation-monitoring-page/components/operation-details-dialog/operation-details-dialog';
import { OrchestrationShellComponent } from '@app/pages/admin/orchestration-shell/orchestration-shell';
import { AdminNotificationsShellComponent } from '@app/pages/admin/admin-notifications-shell/admin-notifications-shell';
import { AdminNotificationsPageComponent } from '@app/pages/admin/admin-notifications-page/admin-notifications-page';
import { AdminNotificationRulePageComponent } from '@app/pages/admin/admin-notification-rule-page/admin-notification-rule-page';
import { OrchestrationOverviewPageComponent } from '@app/pages/admin/orchestration-overview-page/orchestration-overview-page';
import { OrchestrationResourcesPageComponent } from '@app/pages/admin/orchestration-resources-page/orchestration-resources-page';
import { OrchestrationCommandConfigPageComponent } from '@app/pages/admin/orchestration-command-config-page/orchestration-command-config-page';
import { OrchestrationHostLayoutPageComponent } from '@app/pages/admin/orchestration-host-layout-page/orchestration-host-layout-page';
import { OrchestrationGeoServerPageComponent } from '@app/pages/admin/orchestration-geoserver-page/orchestration-geoserver-page';
import { OrchestrationDatabasesPageComponent } from '@app/pages/admin/orchestration-databases-page/orchestration-databases-page';
import { OrchestrationInstanceFillPageComponent } from '@app/pages/admin/orchestration-instance-fill-page/orchestration-instance-fill-page';
import { OrchestrationProcessesPageComponent } from '@app/pages/admin/orchestration-processes-page/orchestration-processes-page';
import { OrchestrationProcessPageComponent } from '@app/pages/admin/orchestration-process-page/orchestration-process-page';
import { OrchestrationEventPageComponent } from '@app/pages/admin/orchestration-event-page/orchestration-event-page';
import { OrchestrationSatelliteProductPageComponent } from '@app/pages/admin/orchestration-satellite-product-page/orchestration-satellite-product-page';
import { OrchestrationSubscriptionPageComponent } from '@app/pages/admin/orchestration-subscription-page/orchestration-subscription-page';
import { DeveloperCatalogPageComponent } from '@app/pages/admin/developer-catalog-page/developer-catalog-page';
import { DeveloperCatalogCommandPageComponent } from '@app/pages/admin/developer-catalog-page/developer-catalog-command-page/developer-catalog-command-page';
import { DeveloperCatalogJobPageComponent } from '@app/pages/admin/developer-catalog-page/developer-catalog-job-page/developer-catalog-job-page';
import { codeCatalogGuard } from './guards/code-catalog.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'auth-error',
    component: AuthErrorComponent,
  },
  {
    path: 'ui-kit',
    component: DataTableDemoComponent,
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authCheckGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'main-menu',
      },
      {
        path: 'crop-monitoring',
        component: CropMonitoringPageComponent,
        data: { breadcrumb: 'Crop monitoring', title: 'Crop monitoring: Main page' },
        children: [
          {
            path: '',
            component: CropMonitoringSummaryComponent,
            data: { breadcrumb: '', title: 'Crop monitoring: Main page' },
          },
          {
            path: 'gis',
            component: GisRequestComponent,
          },
          {
            path: 'requests',
            component: RequestsPageComponent,
            data: { breadcrumb: 'Bids', title: 'Crop monitoring: Bids' },
            children: [
              {
                path: 'add',
                component: RequestAddPageComponent,
                data: { breadcrumb: 'Add request', title: 'Crop monitoring: Add request' },
              },
              {
                path: 'edit/:id',
                component: RequestAddPageComponent,
                data: { breadcrumb: 'Edit request', title: 'Crop monitoring: Edit request' },
              },
            ],
          },
          {
            path: 'anomalies-map',
            component: AnomaliesMapPageComponent,
            data: {
              breadcrumb: 'ANOMALIES_MAP_PAGE_TITLE',
              title: 'Crop monitoring: Anomaly map',
            },
          },
          {
            path: 'mobile-templates',
            component: MobileTemplatesPageComponent,
            data: { breadcrumb: 'Mobile templates', title: 'Mobile templates' },
          },
          {
            path: 'satellite-images',
            component: CropMonitoringSatelliteComponent,
            data: {
              breadcrumb: 'SATELLITE_IMAGES_AND_INDICES_MOSAIC',
              title: 'SATELLITE_IMAGES_AND_INDICES_MOSAIC',
            },
          },
          {
            path: 'recommendations-for-farmers',
            component: FarmerRecommendationsPageComponent,
            data: {
              breadcrumb: 'Recommendations for farmers',
              title: 'Recommendations for farmers',
            },
          },
          {
            path: 'users',
            component: UnderDevelopmentComponent,
            data: { breadcrumb: 'Users', title: 'Crop monitoring: Users' },
          },
          {
            path: 'administration',
            component: CropMonitoringAdministrationMenuComponent,
            canActivate: [AdminGuard],
            data: { breadcrumb: 'Administration', title: 'Crop Monitoring Administration' },
            children: [
              {
                path: 'scheduler',
                component: TaskSchedulerPageComponent,
                data: {
                  breadcrumb: 'Task Scheduler',
                  title: 'Task Scheduler',
                  filterKeywords: ['SatelliteIndices'],
                  parentRoute: '/crop-monitoring/administration',
                },
              },
              {
                path: 'logging',
                component: LoggingPageComponent,
                data: {
                  breadcrumb: 'Logging',
                  title: 'Crop Monitoring: Logging',
                  filterKeywords: ['CropMonitoring'],
                  parentRoute: '/crop-monitoring/administration',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'dictionaries',
        loadChildren: () =>
          import('@app/pages/dictionaries-page/dictionaries.routes').then((m) => m.dictionariesRoutes),
        data: { breadcrumb: 'Directories', title: 'Directories' },
      },
      {
        path: 'general-map',
        loadChildren: () =>
          import('@app/pages/general-map/general-map.routing').then((m) => m.GeneralMapRouting),
        data: {breadcrumb: 'GENERAL_GIS.TITLE', title: 'GENERAL_GIS.TITLE'},
      },
      {
        path: 'electronic-field-map',
        loadChildren: () =>
          import('@app/pages/electronic-field-map/electronic-fields-map.routing').then(
            (m) => m.ElectronicFieldsMapRouting,
          ),
        data: { breadcrumb: 'Electronic Field Maps', title: 'Electronic Field Maps' },
      },
      {
        path: 'main-menu',
        component: MainMenuComponent,
        data: { breadcrumb: 'Main menu', title: 'Main menu' },
      },
      {
        path: 'weather',
        data: { breadcrumb: 'Weather' },
        children: [
          {
            path: '',
            component: WeatherMainMenuComponent,
            data: { title: 'Weather', breadcrumb: null },
          },
          {
            path: 'gis',
            component: GisPageRefactoredNewComponent,
            data: { breadcrumb: 'GIS', title: 'GIS' },
          },
          {
            path: 'tile-map',
            component: TileMap,
            data: { breadcrumb: 'Tile map', title: 'Tile map' },
          },
          {
            path: 'administration',
            component: WeatherAdministrationMenuComponent,
            canActivate: [AdminGuard],
            data: { breadcrumb: 'Administration', title: 'Weather Administration' },
            children: [
              {
                path: 'scheduler',
                component: TaskSchedulerPageComponent,
                data: {
                  breadcrumb: 'Task Scheduler',
                  title: 'Task Scheduler',
                  filterKeywords: ['Era', 'IBM', 'Ibm', 'Ugm'],
                  parentRoute: '/weather/administration',
                },
              },
              {
                path: 'data-processing',
                component: WeatherLoggingComponent,
                data: { breadcrumb: 'ProcessedDataProtocol', title: 'Weather: ProcessedDataProtocol' },
              },
              {
                path: 'logging',
                component: LoggingPageComponent,
                data: {
                  breadcrumb: 'Logging',
                  title: 'Weather Administration: Logging',
                  filterKeywords: ['Era', 'IBMWeather', 'Ugm', 'Weather'],
                  parentRoute: '/weather/administration',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'gis',
        redirectTo: 'weather/gis',
        pathMatch: 'full',
      },
      {
        path: 'tile-map',
        redirectTo: 'weather/tile-map',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        data: { breadcrumb: 'Administration', title: 'Administration' },
        canActivate: [AdminGuard],
        children: [
          {
            path: '',
            component: ElectronicFieldMapPageComponent,
            data: { breadcrumb: null },
          },
          {
            path: 'task-scheduler',
            component: TaskSchedulerPageComponent,
            data: {
              breadcrumb: 'Task Scheduler',
              title: 'Administration: Task Scheduler',
              parentRoute: '/admin',
            },
          },
          {
            path: 'orchestration',
            component: OrchestrationShellComponent,
            canActivate: [AdminGuard],
            data: { breadcrumb: 'Orchestration', title: 'Administration: Orchestration' },
            children: [
              { path: '', component: OrchestrationOverviewPageComponent, data: { breadcrumb: null } },
              { path: 'instance-fill', component: OrchestrationInstanceFillPageComponent, data: { breadcrumb: 'Instance fill' } },
              { path: 'processes', component: OrchestrationProcessesPageComponent, data: { breadcrumb: 'Processes' } },
              {
                path: 'process-flow-test',
                loadComponent: () => import('@app/pages/admin/process-flow-test-page/process-flow-test-page').then(m => m.ProcessFlowTestPageComponent),
                data: { breadcrumb: 'FLOW_TEST_TITLE' },
              },
              {
                path: 'processes/:processKey',
                component: OrchestrationProcessPageComponent,
                data: { breadcrumb: 'Process details' },
              },
              {
                path: 'events',
                pathMatch: 'full',
                redirectTo: () => inject(Router).createUrlTree(
                  ['/admin/orchestration/processes'],
                  { queryParams: { order: 'events' } },
                ),
              },
              {
                path: 'events/:eventKey',
                component: OrchestrationEventPageComponent,
                data: { breadcrumb: 'Event details' },
              },
              {
                path: 'satellite-products/:productId',
                component: OrchestrationSatelliteProductPageComponent,
                data: { breadcrumb: 'Satellite product analysis' },
              },
              { path: 'assignments', component: AssignmentsPageComponent, data: { breadcrumb: 'Assignments' } },
              {
                path: 'assignments/:assignmentId',
                component: OperationDetailsDialogComponent,
                data: { breadcrumb: 'Assignment details', operationKind: 'Assignment' },
              },
              { path: 'monitoring', component: OperationMonitoringPageComponent, data: { breadcrumb: 'Operation Monitoring' } },
              {
                path: 'storage',
                component: OrchestrationDatabasesPageComponent,
                data: { breadcrumb: 'Storage' },
              },
              {
                path: 'databases',
                pathMatch: 'full',
                redirectTo: (snapshot) => inject(Router).createUrlTree(
                  ['/admin/orchestration/storage'],
                  { queryParams: snapshot.queryParams },
                ),
              },
              {
                path: 'jobs/:jobId',
                component: OperationDetailsDialogComponent,
                data: { breadcrumb: 'JobExecution', operationKind: 'JobExecution' },
              },
              {
                path: 'host-layout',
                component: OrchestrationHostLayoutPageComponent,
                data: { breadcrumb: 'HOST_LAYOUT_TITLE' },
              },
              {
                path: 'geoserver',
                component: OrchestrationGeoServerPageComponent,
                data: { breadcrumb: 'GEOSERVER_MONITOR_TITLE' },
              },
              { path: 'subscriptions', component: ProcessSubscriptionsPageComponent, data: { breadcrumb: 'Subscriptions' } },
              {
                path: 'subscriptions/:subscriptionId',
                component: OrchestrationSubscriptionPageComponent,
                data: { breadcrumb: 'Subscription details' },
              },
              { path: 'resources', component: OrchestrationResourcesPageComponent, data: { breadcrumb: 'Resource profiles' } },
              {
                path: 'command-config',
                component: OrchestrationCommandConfigPageComponent,
                data: { breadcrumb: 'Command configuration' },
              },
              {
                path: 'command-config/:sectionName',
                component: OrchestrationCommandConfigPageComponent,
                data: { breadcrumb: 'Command configuration' },
              },
              {
                path: 'code-catalog',
                component: DeveloperCatalogPageComponent,
                canActivate: [codeCatalogGuard],
                data: { breadcrumb: 'Code catalog', title: 'Administration: Code catalog' },
              },
              {
                path: 'code-catalog/commands/:name',
                component: DeveloperCatalogCommandPageComponent,
                canActivate: [codeCatalogGuard],
                data: {
                  breadcrumb: 'Command',
                  title: 'Administration: Code catalog command',
                  parentRoute: '/admin/orchestration/code-catalog',
                },
              },
              {
                path: 'code-catalog/jobs/:name',
                component: DeveloperCatalogJobPageComponent,
                canActivate: [codeCatalogGuard],
                data: {
                  breadcrumb: 'Job',
                  title: 'Administration: Code catalog job',
                  parentRoute: '/admin/orchestration/code-catalog',
                },
              },
              {
                path: 'external-service-calls',
                loadComponent: () =>
                  import('@app/pages/admin/external-service-calls-page/external-service-calls-page')
                    .then(m => m.ExternalServiceCallsPageComponent),
                data: {
                  breadcrumb: 'External service calls',
                  title: 'Administration: External service calls',
                  parentRoute: '/admin/orchestration',
                },
              },
              {
                path: 'access',
                loadComponent: () =>
                  import('@app/pages/admin/orchestration-access-page/orchestration-access-page')
                    .then(m => m.OrchestrationAccessPageComponent),
                data: { breadcrumb: 'Access' },
              },
              {
                path: 'settings',
                data: { breadcrumb: 'SYSTEM_SETTINGS_TITLE' },
                children: [
                  { path: '', pathMatch: 'full', redirectTo: 'connections' },
                  { path: 'email', pathMatch: 'full', redirectTo: 'connections' },
                  { path: 'ftp', pathMatch: 'full', redirectTo: 'connections' },
                  { path: 's3', pathMatch: 'full', redirectTo: 'connections' },
                  {
                    path: 'connections',
                    loadComponent: () => import('@app/pages/admin/system-settings-page/system-settings-page').then(m => m.SystemSettingsPageComponent),
                    data: { breadcrumb: 'SYSTEM_SETTINGS_CONNECTIONS', connection: 'connections' },
                  },
                  {
                    path: 'proxies',
                    loadComponent: () => import('@app/pages/admin/system-settings-page/system-settings-page').then(m => m.SystemSettingsPageComponent),
                    data: { breadcrumb: 'SYSTEM_SETTINGS_PROXIES', connection: 'proxies' },
                  },
                ],
              },
              {
                path: 'notifications',
                component: AdminNotificationsShellComponent,
                data: { breadcrumb: 'adminNotifications.title', title: 'Administration: Notifications' },
                children: [
                  {
                    path: '',
                    component: AdminNotificationsPageComponent,
                    data: { breadcrumb: null, tab: 'rules' },
                  },
                  {
                    path: 'new',
                    component: AdminNotificationsPageComponent,
                    data: { breadcrumb: 'adminNotifications.createRule', tab: 'rules' },
                  },
                  {
                    path: 'rules/:ruleId',
                    component: AdminNotificationRulePageComponent,
                    data: { breadcrumb: 'adminNotifications.rules' },
                  },
                  {
                    path: 'templates',
                    component: AdminNotificationsPageComponent,
                    data: { breadcrumb: 'adminNotifications.templates', tab: 'templates' },
                  },
                  {
                    path: 'messages',
                    component: AdminNotificationsPageComponent,
                    data: { breadcrumb: 'adminNotifications.messages', tab: 'messages' },
                  },
                  {
                    path: 'journal',
                    component: AdminNotificationsPageComponent,
                    data: { breadcrumb: 'adminNotifications.journal', tab: 'journal' },
                  },
                  {
                    path: 'settings',
                    loadComponent: () =>
                      import('@app/pages/admin/admin-notification-delivery-page/admin-notification-delivery-page').then(
                        (m) => m.AdminNotificationDeliveryPageComponent,
                      ),
                    data: { breadcrumb: 'adminNotifications.settings' },
                  },
                ],
              },
            ],
          },
          {
            path: 'user-management',
            component: UserManagementPageComponent,
            canActivate: [AdminGuard],
            data: { breadcrumb: 'User Management', title: 'Administration: User Management' },
          },
          {
            path: 'logging',
            component: LoggingPageComponent,
            data: { breadcrumb: 'Logging', title: 'Administration: Logging' },
          },
          {
            path: 'system-status',
            component: SystemStatusPageComponent,
            data: { breadcrumb: 'System Status', title: 'Administration: System Status' },
          },
          {
            path: 'ai-modules/:serviceKey/models/:modelId',
            loadComponent: () =>
              import('@app/pages/admin/ai-models-page/ai-models-page').then(m => m.AiModelsPageComponent),
            data: { aiView: 'model', breadcrumb: 'AI Models', title: 'Administration: AI Models' },
          },
          {
            path: 'ai-modules/:serviceKey',
            loadComponent: () =>
              import('@app/pages/admin/ai-models-page/ai-models-page').then(m => m.AiModelsPageComponent),
            data: { aiView: 'module', breadcrumb: 'AI Models', title: 'Administration: AI Models' },
          },
          {
            path: 'ai-models',
            loadComponent: () =>
              import('@app/pages/admin/ai-models-page/ai-models-page').then(m => m.AiModelsPageComponent),
            data: { aiView: 'catalog', breadcrumb: 'AI Models', title: 'Administration: AI Models' },
          },
          {
            path: 'ai-training-datasets',
            loadComponent: () =>
              import('@app/pages/admin/ai-training-datasets-page/ai-training-datasets-page')
                .then(m => m.AiTrainingDatasetsPageComponent),
            data: { breadcrumb: 'Training datasets', title: 'Administration: Training datasets' },
          },
          {
            path: 'external-service-calls',
            redirectTo: 'orchestration/external-service-calls',
            pathMatch: 'full',
          },
          {
            path: 'developer-catalog',
            redirectTo: 'orchestration/code-catalog',
            pathMatch: 'full',
          },
          {
            path: 'developer-catalog/commands/:name',
            redirectTo: 'orchestration/code-catalog/commands/:name',
          },
          {
            path: 'developer-catalog/jobs/:name',
            redirectTo: 'orchestration/code-catalog/jobs/:name',
          },
          {
            path: 'appeals',
            component: AppealsPageComponent,
            data: { breadcrumb: 'Appeals', title: 'Admin: Appeals List' },
          },
          {
            path: 'appeals/chat',
            component: ChatComponent,
            data: { breadcrumb: 'Chats', title: 'Appeals Chats' },
          },
          {
            path: 'appeals/chat/:id',
            component: ChatComponent,
            data: { breadcrumb: 'Chats', title: 'Support Chats' },
          },
          {
            path: 'file-storage',
            component: FileStorageManagementPageComponent,
            data: { breadcrumb: 'File Storage Management', title: 'Admin: File Storage Management' },
          },
          {
            path: 'data-management',
            component: DataManagementPageComponent,
            data: { breadcrumb: 'Data Management', title: 'Admin: Data Management' },
          },
          {
            path: 'system-documentation',
            component: SystemDocumentationPageComponent,
            data: { breadcrumb: 'System Documentation', title: 'Administration: System Documentation' },
          },
          {
            path: 'system-documentation-blocks',
            component: SystemDocumentationBlocksPageComponent,
            data: { breadcrumb: 'System Documentation Blocks', title: 'Administration: System Documentation Blocks' },
          },
          {
            path: 'maintenance',
            component: MaintenancePageComponent,
            data: { breadcrumb: 'adminMaintenance.title', title: 'Administration: Maintenance commands' },
          },
          {
            path: 'mobile-settings',
            component: MobileSettingsPageComponent,
            data: { breadcrumb: 'adminMobileSettings.title', title: 'Administration: Mobile app settings' },
          },
          {
            path: 'notifications/templates',
            redirectTo: 'orchestration/notifications/templates',
          },
          {
            path: 'notifications/messages',
            redirectTo: 'orchestration/notifications/messages',
          },
          {
            path: 'notifications/journal',
            redirectTo: 'orchestration/notifications/journal',
          },
          {
            path: 'notifications/settings',
            redirectTo: 'orchestration/notifications/settings',
          },
          {
            path: 'notifications/new',
            redirectTo: 'orchestration/notifications/new',
          },
          {
            path: 'notifications/rules/:ruleId',
            redirectTo: 'orchestration/notifications/rules/:ruleId',
          },
          {
            path: 'notifications',
            redirectTo: 'orchestration/notifications',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('@app/pages/user-notifications-inbox-page/user-notifications-inbox-page').then(
            (m) => m.UserNotificationsInboxPageComponent,
          ),
        data: { breadcrumb: 'userInbox.title', title: 'Notifications' },
      },
      {
        path: 'soil-composition',
        component: UnderDevelopmentComponent,
        data: { breadcrumb: 'Soil composition', title: 'Soil composition' },
      },
      {
        path: 'uav-data',
        component: UavDataComponent,
        data: { breadcrumb: 'UAV data', title: 'UAV data' },
      },
      {
        path: 'satellite-data',
        data: { breadcrumb: 'Satellite Data', title: 'Satellite Data' },
        children: [
          {
            path: '',
            component: SatelliteDataComponent,
            data: { breadcrumb: null },
          },
          {
            path: 'admin',
            component: SatelliteDataComponent,
            canActivate: [AdminGuard],
            data: { breadcrumb: 'Administration' },
          },
          {
            path: 'scheduler',
            component: TaskSchedulerPageComponent,
            canActivate: [AdminGuard],
            data: {
              breadcrumb: 'Task Scheduler',
              title: 'Task Scheduler',
              filterKeywords: ['Sentinel', 'Landsat'],
              parentRoute: '/satellite-data/admin',
            },
          },
        ],
      },
      {
        path: 'satellite-images',
        component: SatelliteImagesComponent,
        data: { breadcrumb: 'Satellite Images', title: 'Satellite Images' },
      },
      {
        path: 'satellite-images-admin',
        component: SatelliteImagesAdminComponent,
        canActivate: [AdminGuard],
        data: { breadcrumb: 'Satellite images admin', title: 'Satellite Images Admin' },
      },
      {
        path: 'map',
        component: UnderDevelopmentComponent,
        data: { breadcrumb: 'Map', title: 'Map' },
      },
      {
        path: 'crop-yield-forecasts',
        data: { breadcrumb: 'Crop Yield Forecasts', title: 'Crop Yield Forecasts' },
        children: [
          {
            path: '',
            component: CropYieldForecastsPageComponent,
            data: { breadcrumb: null },
          },
          {
            path: 'list',
            component: CropYieldForecastListComponent,
            data: { breadcrumb: 'List', title: 'Forecast List' },
          },
          {
            path: 'analysis',
            component: CropYieldAnalysisComponent,
            data: { breadcrumb: 'Analysis', title: 'Yield Analysis' },
          },
        ],
      },
      {
        path: 'fields-identification',
        data: { breadcrumb: 'Fields identification', title: 'Fields identification' },
        children: [
          {
            path: '',
            component: FieldsIdentificationPageComponent,
            data: { breadcrumb: null },
          },
          {
            path: 'list',
            component: FieldsIdentificationListComponent,
            data: { breadcrumb: 'Boundaries List', title: 'Boundaries List' },
          },
          {
            path: 'gis',
            component: FieldsIdentificationMapComponent,
            data: { breadcrumb: 'GIS', title: 'GIS' },
          },
        ],
      },
      {
        path: 'crop-identification',
        data: { breadcrumb: 'Crop identification', title: 'Crop identification' },
        children: [
          {
            path: '',
            component: CropIdentificationMainComponent,
            data: { breadcrumb: 'Crop identification', title: 'Crop identification' },
          },
          {
            path: 'gis',
            component: GisCropIdentification,
            data: { breadcrumb: 'GIS', title: 'GIS' },
          },
          {
            path: 'list',
            component: CropIdentificationList,
            data: { breadcrumb: 'Crop identification', title: 'Crop identification' },
          },
        ],
      },
      {
        path: 'reports',
        component: ReportingAnalyticsPageComponent,
        data: { breadcrumb: 'reporting_analytics.title', title: 'reporting_analytics.title' },
      },
      {
        path: 'fields-passport',
        component: UnderDevelopmentComponent,
        data: { breadcrumb: 'fields-passport', title: 'fields-passport' },
      },
      {
        path: 'upload-images',
        redirectTo: 'electronic-field-map/upload-images',
        pathMatch: 'full',
      },
      {
        path: 'field',
        component: PassportMenuGeneral,
        data: { breadcrumb: 'fields', title: 'fields' },
      },
      {
        path: 'services',
        component: UnderDevelopmentComponent,
        data: { breadcrumb: 'Services', title: 'Services' },
      },
      {
        path: 'profile',
        component: ProfilePageComponent,
        data: { breadcrumb: 'Profile', title: 'Личный кабинет' },
      },
      {
        path: 'settings',
        component: UnderDevelopmentComponent,
        data: { breadcrumb: 'Settings', title: 'Settings' },
      },
      {
        path: 'users',
        component: UnderDevelopmentComponent,
        data: { breadcrumb: 'Users', title: 'Users' },
      },
      {
        path: 'api-test',
        component: ApiTestComponent,
        data: { breadcrumb: 'API Test', title: 'API Configuration Test' },
      },
      {
        path: 'help',
        children: [
          {
            path: 'documentation',
            component: DocumentationPageComponent,
            data: { breadcrumb: 'Electronic Documentation', title: 'Electronic Documentation' },
          },
          {
            path: 'support-tickets',
            component: UserSupportTicketsPageComponent,
            data: { breadcrumb: 'Support Tickets', title: 'Support Tickets' },
          },
          {
            path: 'support-tickets/chat/:id',
            component: UserChatComponent,
            data: { breadcrumb: 'Chats', title: 'Support Chats' },
          },
        ],
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
